import { Component, computed, effect, inject, input, output, signal } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { RidBottomButton } from '../../components/rid-bottom-button/rid-bottom-button';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidModalBackground } from '../../components/rid-modal-background/rid-modal-background';
import { RidRatingModal } from '../../components/rid-rating-modal/rid-rating-modal';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { RidVoiceRecorder } from '../../components/rid-voice-recorder/rid-voice-recorder';
import { ExpressionService } from '../../services/expression-service.service';

@Component({
  selector: 'rid-expressive-reading',
  imports: [
    RidBottomButton,
    RidMechanicBackground,
    RidMechanicWrapper,
    RidTopBar,
    RidMechanicContent,
    RidMechanicTitle,
    RidModalBackground,
    RidRatingModal,
    RidVoiceRecorder,
  ],
  templateUrl: './rid-expressive-reading.html',
  host: {
    class: 'block',
  },
})
export class RidExpressiveReading {
  protected readonly $expressionService = inject(ExpressionService);

  steps = input.required<
    ({
      content: string;
      evaluate: boolean;
    } & ({ mode: 'CAREFUL' } | { mode: 'PUNCTUATION' } | { mode: 'EXPRESSIVE'; expression: string[] }))[]
  >();
  index = signal<number>(0);
  step = computed(() => this.steps()[this.index()]);
  isRating = signal(false);

  finished = output<void>();

  constructor() {
    effect(async () => {
      const step = this.step();
      if (step.mode === 'EXPRESSIVE') {
        await delay(1000);
        await this.$expressionService.choseExpression(step.expression, 'CLIENT');
      } else {
        this.$expressionService.clearExpression('CLIENT');
      }
    });
  }

  highlightPunctuation(text: string): string {
    return text.replace(/([.,!?;:])/g, '<span class="text-purple-500 underline underline-offset-4">$1</span>');
  }

  rate() {
    this.isRating.set(true);
  }

  handleRating() {
    this.isRating.set(false);
    this.next();
  }

  async next() {
    const isLast = this.index() + 1 >= this.steps().length;
    if (isLast) {
      this.finish();
    } else {
      this.index.set(this.index() + 1);
    }
  }

  finish() {
    this.$expressionService.clearExpression('CLIENT');
    this.finished.emit();
  }
}
